<template>
  <div class="page-view">
    <!-- 面包屑 -->
    <a-breadcrumb class="page-breadcrumb">
      <a-breadcrumb-item>项目任务</a-breadcrumb-item>
      <a-breadcrumb-item>签约项目</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 列表 -->
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :row-key="(record) => record.id"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <!-- 费率 -->
      <template slot="fax" slot-scope="text">
        {{ text }}%
      </template>
      <!-- 结束日期 -->
      <template slot="end_at" slot-scope="text">
        {{ text || '长期' }}
      </template>
      <!-- 操作 -->
      <template slot="operate" slot-scope="text, record">
        <!-- a 标签 -->
        <a class="operate-item" @click="touchSetDep(record)">设置部门</a>
        <a class="operate-item" @click="touchViewTask(record)">查看任务</a>
      </template>
    </a-table>
    <!-- 提示 -->
    <a-alert type="info" class="page-hint">
      <div slot="description" style="line-height: 26px;">
        项目说明：
        <br>
        1、跟平台签订承包项目后，才可以基于项目发布任务。
        <br>
        2、项目无法自行创建，需联系商务签订合同后，由后台自行生成。
        <br>
        3、费率包含了6%的增值税发票。
      </div>
    </a-alert>
    <!-- 设置部门 -->
    <SetDepModal ref="SetDepModal"></SetDepModal>
  </div>
</template>

<script>
import Pub from '@/utils/public'
import SetDepModal from './components-project-list/SetDepModal'
import { getProjectList } from '@/api/request'
// 列字段
const columns = [
  {
    title: '项目ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '项目名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '业务类型',
    dataIndex: 'business_type_name',
    key: 'business_type_name'
  },
  {
    title: '费率',
    dataIndex: 'fax',
    key: 'fax',
    scopedSlots: { customRender: 'fax' }
  },
  {
    title: '开始日期',
    dataIndex: 'start_at',
    key: 'start_at'
  },
  {
    title: '结束日期',
    dataIndex: 'end_at',
    key: 'end_at',
    scopedSlots: { customRender: 'end_at' }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    scopedSlots: { customRender: 'operate' }
  }
]
export default {
  components: {
    SetDepModal
  },
 data () {
    return {
      // 列字段
      columns,
      // 数据源
      dataSource: [],
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      }
    }
  },
  created () {
    // 获取项目列表
    this.getProjectList()
  },
  methods: {
    // 分页
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 获取项目列表
      this.getProjectList()
    },
    // 设置部门
    touchSetDep (record) {
      this.$refs['SetDepModal'].showModal(record)
    },
    // 查看任务
    touchViewTask (record) {
      Pub.JUMP_ROUTER('/task-list', { id: record.id })
    },
    // 获取任务列表
    getProjectList () {
      this.isLoading = true
      const params = {
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      getProjectList(params).then(res => {
        this.isLoading = false
        const { code, data, message } = res
        if (code === 0) {
          const dataSource = data.data
          // 处理部门ID
          dataSource.forEach(item => {
            const department = item.department || []
            const deps = []
            department.forEach(dep => {
              deps.push(dep.dept_id)
            })
            item.deps = deps
          })
          this.dataSource = dataSource
          this.pagination.total = data.total
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-view {
  padding: 24px 32px;
}
.page-breadcrumb {
  margin-bottom: 24px;
}
.operate-item:not(:first-child) {
  margin-left: 8px;
}
.page-hint {
  margin-top: 20px;
}
</style>